import type { IPagesWrapper } from "app/pages/segments/redesigned-wizard/segment-wizard/types";
import { RuleTypes } from "app/pages/segments/redesigned-wizard/segment-wizard/types";
import type { FC } from "react";
import React from "react";
import { FlexedDiv } from "app/pages/segments/redesigned-wizard/segment-wizard/styledComponents";
import {
    AndSeparatorText,
    CircleIndicator,
    GroupConnectorHorizontalExtension,
    GroupConnectorWrapper,
    PagesTitle,
    PagesWrapperContainer,
} from "app/pages/segments/redesigned-wizard/segment-wizard/segment-rules-section/segmentRulesStyles";
import { RulesGroup } from "app/pages/segments/redesigned-wizard/segment-wizard/segment-rules-section/RulesGroup";
import {
    doAllRuleFiltersDefined,
    doesAtLeastOneRuleExist,
} from "app/pages/segments/redesigned-wizard/segment-wizard/segmentWizardHelpers";
import { AssetsService } from "app/services/AssetsService";
import { i18nFilter } from "app/filters/i18nFilter";

export const PagesWrapper: FC<IPagesWrapper> = (props) => {
    const {
        rules,
        title,
        isMidTierUser,
        onCloseRule,
        domain,
        getUrlsPreview,
        hideUrlsPreview,
        hasExistingUrlsCompoundStringNoRobots,
        updateWordPredictionsIfNeeded,
        ruleType,
        doExcludeRulesExist,
        isMidtierUserAndOneRuleCreated,
        resetActiveIndex,
    } = props;

    const ruleFilterRowProps = {
        isMidTierUser,
        onCloseRule,
        domain,
        getUrlsPreview,
        hideUrlsPreview,
        hasExistingUrlsCompoundStringNoRobots,
        updateWordPredictionsIfNeeded,
        ruleType,
        doExcludeRulesExist,
        isMidtierUserAndOneRuleCreated,
        resetActiveIndex,
    };

    return (
        <PagesWrapperContainer isExclude={ruleType === RuleTypes.exclude}>
            <FlexedDiv>
                <PagesTitle>{title}</PagesTitle>
                <CircleIndicator isInclude={ruleType === RuleTypes.include} />
            </FlexedDiv>
            {rules.map((rule, ruleIndex) => {
                const hasAtLeastOneRule = doesAtLeastOneRuleExist(rules[ruleIndex]);
                const isRuleNotLastAndNotEmpty =
                    rules.length > ruleIndex + 1 && hasAtLeastOneRule && doesAtLeastOneRuleExist(rules[ruleIndex + 1]);
                const isFinalGroup = isRuleNotLastAndNotEmpty || doAllRuleFiltersDefined(rule, isMidTierUser);
                const isNextRuleFinal =
                    isFinalGroup &&
                    rules.length > ruleIndex + 1 &&
                    !doAllRuleFiltersDefined(rules[ruleIndex + 1], isMidTierUser);
                const ruleFilterProps = {
                    ...ruleFilterRowProps,
                    ruleIndex,
                    isFinalGroup,
                    displayForEmptyRule:
                        ruleIndex !== 0 ? doAllRuleFiltersDefined(rules[ruleIndex - 1], isMidTierUser) : true,
                    rule: rules[ruleIndex],
                    nextRule: rules?.[ruleIndex + 1],
                    hasAtLeastOneRule,
                };
                const hideRulesGroup =
                    rules.length > 1 &&
                    ruleIndex === rules.length - 1 &&
                    doesAtLeastOneRuleExist(rules[ruleIndex - 1]) &&
                    !doAllRuleFiltersDefined(rules[ruleIndex - 1], isMidTierUser);
                return (
                    <React.Fragment key={`rulesGroup_${ruleType}_${ruleIndex}`}>
                        {!hideRulesGroup && <RulesGroup {...ruleFilterProps} />}
                        {isFinalGroup && (
                            <>
                                <GroupConnectorWrapper ruleIndex={ruleIndex}>
                                    <img src={AssetsService.assetUrl(`/images/segments/group-connector-pipe.svg`)} />
                                </GroupConnectorWrapper>
                                <AndSeparatorText>
                                    {i18nFilter()("segmentsWizard.addFilters.and.label")}
                                </AndSeparatorText>
                                {!isNextRuleFinal && <GroupConnectorHorizontalExtension ruleIndex={ruleIndex} />}
                            </>
                        )}
                    </React.Fragment>
                );
            })}
        </PagesWrapperContainer>
    );
};
